import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "d-sm-flex align-items-center" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  key: 1,
  class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-secondary fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none",
  type: "button",
  disabled: ""
}
const _hoisted_8 = { class: "d-flex align-items-center" }
const _hoisted_9 = { class: "row row-cols-1 row-cols-md-2 row-cols-xl-3 g-2 g-xl-3" }
const _hoisted_10 = { class: "ol-md-4" }
const _hoisted_11 = { class: "card h-md-100" }
const _hoisted_12 = { class: "card-body d-flex flex-column flex-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_RoleCard = _resolveComponent("RoleCard")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_ctx.valideEtape3)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.telecharger && _ctx.telecharger(...args))),
                disabled: _ctx.isLoading,
                class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none",
                type: "button"
              }, [
                _cache[3] || (_cache[3] = _createElementVNode("i", { class: "flaticon-download position-relative ms-5 fs-12" }, null, -1)),
                (!_ctx.isLoading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, "Exporter"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_6, [...(_cache[2] || (_cache[2] = [
                      _createElementVNode("span", {
                        class: "spinner-grow spinner-grow-sm me-2",
                        role: "status",
                        "aria-hidden": "true"
                      }, null, -1),
                      _createTextVNode(" Export en cours... ", -1)
                    ]))]))
              ], 8, _hoisted_4))
            : _createCommentVNode("", true),
          (!_ctx.valideEtape3)
            ? (_openBlock(), _createElementBlock("button", _hoisted_7, [...(_cache[4] || (_cache[4] = [
                _createElementVNode("span", {
                  class: "spinner-grow spinner-grow-sm",
                  role: "status",
                  "aria-hidden": "true"
                }, null, -1),
                _createElementVNode("span", { class: "visually-hidden" }, "Chargement...", -1)
              ]))]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_Form, { class: "search-box position-relative me-15" }, {
            default: _withCtx(() => [
              _createVNode(_component_Field, {
                type: "text",
                modelValue: _ctx.motCle,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.motCle) = $event)),
                class: "form-control shadow-none text-black rounded-0 border-0",
                placeholder: "Rechercher un role",
                name: "mot"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_ErrorMessage, {
                name: "mot",
                class: "text-danger"
              }),
              _cache[5] || (_cache[5] = _createElementVNode("button", {
                type: "submit",
                class: "bg-transparent text-primary transition p-0 border-0"
              }, [
                _createElementVNode("i", { class: "flaticon-search-interface-symbol" })
              ], -1))
            ]),
            _: 1
          }),
          _cache[6] || (_cache[6] = _createElementVNode("button", {
            class: "dot-btn lh-1 position-relative top-3 bg-transparent border-0 shadow-none p-0 transition d-inline-block",
            type: "button"
          }, [
            _createElementVNode("i", { class: "flaticon-dots" })
          ], -1))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _cache[10] || (_cache[10] = _createElementVNode("div", { class: "card-title m-15" }, [
            _createElementVNode("h2", { class: "text-center" }, "Ajouter un rôle")
          ], -1)),
          _createElementVNode("div", _hoisted_12, [
            _cache[8] || (_cache[8] = _createTextVNode(" . ", -1)),
            _cache[9] || (_cache[9] = _createElementVNode("i", {
              class: "flaticon-form",
              style: {"font-size":"140px","text-align":"center"}
            }, null, -1)),
            _createVNode(_component_router_link, {
              to: { name: 'AddRolePage' },
              class: "btn btn-primary btn-active-primary"
            }, {
              default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                _createElementVNode("span", { class: "fw-bolder" }, [
                  _createElementVNode("i", { class: "plus" }),
                  _createTextVNode("Ajouter un rôle")
                ], -1)
              ]))]),
              _: 1
            })
          ])
        ])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.roleDatas, (role, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "col-md-4",
          key: index
        }, [
          _createVNode(_component_RoleCard, {
            id: role.id,
            nom: role.description,
            number: role.rolePermissions?.length,
            privileges: role.rolePermissions,
            onDelete: ($event: any) => (_ctx.suppression(role.id,_ctx.roleDatas,'roles','role'))
          }, null, 8, ["id", "nom", "number", "privileges", "onDelete"])
        ]))
      }), 128))
    ])
  ], 64))
}